import { getString } from "utils/Utils";

import { addNotification, LOADING, LoadingAction } from "./actions";

export { addNotification };

export function loading(loading: boolean, action: string | { type: string } | { action: string }): LoadingAction {
    return {
        payload: {
            action: getString(action, ["action", "type"]),
            isLoading: loading
        },
        type: LOADING
    };
}
